package org.ssoft.common.tools

import kotlinx.datetime.UtcOffset
import kotlin.js.*

actual val UtcOffset.Companion.SYSTEM: UtcOffset
    get() = UtcOffset(minutes = -Date().getTimezoneOffset())
